import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { requireGuest } from '@/app/lib/auth-guard';
import { LoginPage } from '@/auth/pages/login';

const loginSearchSchema = z.object({
  redirect: z.string().optional()
});

export const Route = createFileRoute('/_login-signup/login')({
  beforeLoad: () => {
    requireGuest();
  },
  validateSearch: loginSearchSchema,
  component: LoginRoute
});

function LoginRoute() {
  return <LoginPage/>;
}
